function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useReducer } from 'react';
import orderBy from 'lodash/orderBy';
import { TRIBE_OPTIONS } from '@myap/metadata';
import { InputField, AutosuggestField, TextField } from '../../forms/FormikFields';
import { getTribes } from '../actions';
import { FIELD_RACE, FIELD_RECOGNIZED_TRIBE, FIELD_ENROLLED_TRIBE, FIELD_DESCENDANT_TRIBE } from '../constants';
var tribesInitialState = {
  fetching: false,
  data: [],
  error: null
};

var reducer = function reducer(state, _ref) {
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'FETCHING':
      return _objectSpread(_objectSpread({}, state), {}, {
        fetching: true
      });

    case 'FULFILLED':
      return _objectSpread(_objectSpread({}, state), {}, {
        fetching: false,
        data: payload
      });

    case 'REJECTED':
      return _objectSpread(_objectSpread({}, state), {}, {
        fetching: false,
        error: payload
      });

    default:
      return state;
  }
};

export default (function (_ref2) {
  var client = _ref2.client,
      values = _ref2.values,
      initialValues = _ref2.initialValues,
      isCurrentYear = _ref2.isCurrentYear,
      setFieldValue = _ref2.setFieldValue,
      isSubmitting = _ref2.isSubmitting,
      isStudent = _ref2.isStudent,
      raceOptions = _ref2.raceOptions;

  var isNativeAmericanAlaskanSelected = function isNativeAmericanAlaskanSelected() {
    var selectedRaces = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return selectedRaces.some(function (v) {
      return v == raceOptions.nativeAmerican.value;
    });
  };

  var _useReducer = useReducer(reducer, tribesInitialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      tribes = _useReducer2[0],
      dispatch = _useReducer2[1];

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      tribeName = _useState2[0],
      setTribeName = _useState2[1];

  var _useState3 = useState(isNativeAmericanAlaskanSelected(initialValues[FIELD_RACE])),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedNativeAmericanAlaskan = _useState4[0],
      setSelectedNativeAmericanAlaskan = _useState4[1];

  useEffect(function () {
    setSelectedNativeAmericanAlaskan(isNativeAmericanAlaskanSelected(values[FIELD_RACE]));
  }, [values]);
  useEffect(function () {
    function getListOfTribes() {
      return _getListOfTribes.apply(this, arguments);
    }

    function _getListOfTribes() {
      _getListOfTribes = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var listOfTribes;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch({
                  type: 'FETCHING'
                });
                _context.prev = 1;
                _context.next = 4;
                return getTribes({
                  client: client,
                  isStudent: isStudent,
                  isProfessional: !isStudent
                });

              case 4:
                listOfTribes = _context.sent;
                dispatch({
                  type: 'FULFILLED',
                  payload: orderBy(listOfTribes, ['name'], ['asc'])
                });
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                dispatch({
                  type: 'REJECTED',
                  payload: _context.t0
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 8]]);
      }));
      return _getListOfTribes.apply(this, arguments);
    }

    if (values[FIELD_RECOGNIZED_TRIBE] && !tribes.fetching && !tribes.data.length && !isSubmitting) {
      getListOfTribes();
    }
  }, [values, tribes, isSubmitting]);
  useEffect(function () {
    if (values && values[FIELD_ENROLLED_TRIBE] && !tribeName && tribes.data.length) {
      var _tribes$data$find = tribes.data.find(function (_ref3) {
        var id = _ref3.id;
        return id === values[FIELD_ENROLLED_TRIBE];
      }),
          name = _tribes$data$find.name;

      setTribeName(name);
    }
  }, [values, tribes, tribeName]);

  if (selectedNativeAmericanAlaskan && isCurrentYear) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        marginLeft: '27px',
        marginBottom: '16px'
      }
    }, /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("legend", {
      className: "cb-required"
    }, "Are you enrolled in a federally or state recognized tribe?"), /*#__PURE__*/React.createElement(InputField, {
      label: "Yes",
      type: "radio",
      value: true,
      name: FIELD_RECOGNIZED_TRIBE,
      checked: values[FIELD_RECOGNIZED_TRIBE] === true,
      onChange: function onChange(e) {
        var checked = e.target.checked;

        if (checked) {
          setFieldValue(FIELD_RECOGNIZED_TRIBE, true);
        }
      }
    }), /*#__PURE__*/React.createElement(InputField, {
      label: "No",
      type: "radio",
      value: false,
      name: FIELD_RECOGNIZED_TRIBE,
      checked: values[FIELD_RECOGNIZED_TRIBE] === false,
      onChange: function onChange(e) {
        var checked = e.target.checked;

        if (checked) {
          setFieldValue(FIELD_RECOGNIZED_TRIBE, false);
          setFieldValue(FIELD_ENROLLED_TRIBE, null);
          setTribeName('');
        }
      }
    })), values[FIELD_RECOGNIZED_TRIBE] ? /*#__PURE__*/React.createElement(AutosuggestField, {
      name: FIELD_ENROLLED_TRIBE,
      suggestionIdPrefix: "autosuggest-tribe-option",
      label: "In which tribe are you enrolled?",
      placeholder: tribes.fetching ? 'Loading...' : 'Search by tribe name',
      minCharacterSearchLength: 2,
      renderSuggestion: function renderSuggestion(_ref4) {
        var name = _ref4.name;
        return name;
      },
      value: tribeName,
      onChange: function onChange(e) {
        var value = e.target.value;
        setTribeName(value);
        setFieldValue(FIELD_ENROLLED_TRIBE, null);
      },
      required: values[FIELD_RECOGNIZED_TRIBE],
      disabled: tribes.fetching,
      fetchSuggestions: function fetchSuggestions(val) {
        var suggestions = tribes.data.filter(function (tribe) {
          return tribe.name.toLowerCase().includes(val.toLowerCase());
        }).slice(0, 10);
        return {
          suggestions: suggestions,
          total: suggestions.length
        };
      },
      selectSuggestion: function selectSuggestion(val) {
        // console.info(val)
        setTribeName(val.name);
        setFieldValue(FIELD_ENROLLED_TRIBE, val.id);
      },
      validate: function validate() {
        return values[FIELD_RECOGNIZED_TRIBE] && values[FIELD_ENROLLED_TRIBE] ? undefined : 'Error: You must select a tribe from the dropdown.';
      }
    }) : null, /*#__PURE__*/React.createElement(TextField, {
      label: "Of which tribe(s) are you a descendant?",
      placeholder: "Enter name of tribe(s) you are descended from",
      maxLength: 500,
      name: FIELD_DESCENDANT_TRIBE // validate={value => LimitedStringValidation(value)}
      ,
      autocomplete: "off"
    }));
  }

  return null;
});